function ASEANCTDpage() {
  return (
    <>
      <div className="flex items-center gap-2 mb-6">
        <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
        <h3 className="text-lg font-bold text-[#05326D]">
          3. ASEAN CTD – Common Technical Document
        </h3>
      </div>

      <p className="text-md font-bold text-[#05326D] mb-4">
        Region: Southeast Asia (Thailand, Malaysia, Indonesia, etc.)
      </p>
      <p className="text-[#05326D] mt-2">Purpose: Regional harmonization of drug submission </p>

      <p className="text-[#05326D] mb-4 mt-2">Body: National agencies under ASEAN framework</p>


      <p className="text-md font-bold text-[#05326D] mb-4">
        Key Components:
      </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Adapted CTD structure with region-specific formatting</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Local language translations may be required</p>
      <p className="ml-2 mt-2 text-[#05326D]">- DMF or ASMF references depending on country</p>


      <p className="text-md font-bold text-[#05326D] mb-4 mt-4">
        Filing Notes: </p>

      <p className="ml-2 mt-2 text-[#05326D]">- Submission formats vary: eCTD, NeeS, or paper</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Regulatory timelines and expectations differ by country</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Strategic dossier planning is essential for multi-country rollout</p>
      <hr className="border-t border-gray-300 mb-8 mt-8" />
      <p className="text-md font-bold text-[#05326D] mb-4 mt-4">
        Strategic Tip from FDAC: </p>

      <p className="text-[#05326D]">For global dossier success, FDAC recommends:</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Early alignment of DMF/ASMF/CEP with target market requirements</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Robust eCTD publishing and validation workflows</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Lifecycle planning for post-approval changes and renewals</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Cloud-based collaboration for real-time dossier management</p>

    </>

  );
}

export default ASEANCTDpage;
